import React from 'react'

import Base from '../_Base'

const Episodes = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M21 10a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h18zm-1 2H4v7h16v-7zm0-5a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2h16zm-2-3a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2h12z"
      fillRule="evenodd"
    />
  </Base>
)

export default Episodes
